import { render, staticRenderFns } from "./PageUpsertComponent.vue?vue&type=template&id=5d80d44b&"
import script from "./PageUpsertComponent.vue?vue&type=script&lang=ts&"
export * from "./PageUpsertComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports